const toSelectOptions = (items: { key: string; name: string }[]) =>
  items.map((item) => ({
    value: item.key,
    label: item.name,
  }));

export default toSelectOptions;
